// @ts-check
/** Place three airborne challenges above spaced landing surfaces; the last rewards a double jump.
 * @param {import('../game/types.js').LevelDefinition} level
 * @returns {import('../game/types.js').LevelDefinition}
 */
export function withTransistors(level) {
  const candidates = level.solids.filter(s => !s.ceiling && !s.hidden && s.x > level.spawn && s.x + s.width < level.finish && s.y + s.height < 420).map(s => ({ x: s.x + s.width / 2, floor: s.y + s.height }));
  const portal = level.portals?.[0];
  const landing = level.checkpoints?.find(c => c.id === portal?.returnCheckpoint);
  const chosen = new Set();
  const transistors = [.22, .52, .8].flatMap((fraction, index) => {
    if (portal && index === 1) return [];
    const lift = (level.quantum ? [140, 210, 310] : [110, 160, 210])[index];
    const target = portal ? index === 0 ? portal.x : (landing?.x ?? portal.x) + 160 : level.spawn + (level.finish - level.spawn) * fraction;
    const safe = candidates.filter(c => !chosen.has(c) && (!portal || (index === 0 ? c.x <= portal.x + portal.width / 2 : c.x > (landing?.x ?? portal.x) + 24)) && c.floor + lift + 14 < level.height && !level.solids.some(s => !s.hidden && c.x + 12 > s.x && c.x - 12 < s.x + s.width && c.floor + lift + 14 > s.y && c.floor + lift - 14 < s.y + s.height) && !level.solids.some(s => !s.hidden && c.x + 12 > s.x && c.x - 12 < s.x + s.width && s.y + s.height > c.floor && s.y + s.height < c.floor + lift));
    const point = safe.sort((a, b) => Math.abs(a.x - target) - Math.abs(b.x - target))[0];
    if (!point) throw new Error(`No transistor landing in ${level.id}`);
    chosen.add(point); return Object.freeze({ x: point.x, y: point.floor + lift, slot: index });
  }).sort((a, b) => a.x - b.x);
  return Object.freeze({ ...level, transistors: Object.freeze(transistors) });
}
